// The admin icons: 24px stroke glyphs drawn in the current colour, as in the approved Friday
// mockups. The navigation's (Dashboard and Customers join it with their pages), then the row
// actions of lists and editors.
const paths = {
  back: "M19 12H5M12 19l-7-7 7-7",
  // Two overlapping sheets.
  copy: "M9 9h11v11H9zM5 15H4V4h11v1",
  down: "M12 5v14M19 12l-7 7-7-7",
  download: "M12 4v11M7 10l5 5 5-5M5 20h14",
  edit: "M12 20h9M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z",
  // An arrow up and out to the right, for a link that opens a new tab.
  external: "M7 17L17 7M8 7h9v9",
  forward: "M5 12h14M12 5l7 7-7 7",
  // A question mark in a circle, for the docs link.
  help: "M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20zM9.1 9a3 3 0 0 1 5.8 1c0 2-3 3-3 3M12 17h.01",
  // A padlock, for a value that can no longer change.
  lock: "M5 11h14v10H5zM8 11V7a4 4 0 0 1 8 0v4",
  // A picture: a frame, a hill and the sun, for an image that could not load.
  image: "M4 5h16v14H4zM4 16l5-5 4 4 2-2 5 5M15 10.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z",
  send: "M22 2L11 13M22 2l-7 20-4-9-9-4z",
  // Three dots: a 1-unit circle under the 2-unit stroke fills in.
  more: "M5 12a1 1 0 1 0 2 0a1 1 0 1 0-2 0M11 12a1 1 0 1 0 2 0a1 1 0 1 0-2 0M17 12a1 1 0 1 0 2 0a1 1 0 1 0-2 0",
  plus: "M12 5v14M5 12h14",
  trash: "M3 6h18M8 6V4h8v2M6 6l1 14h10l1-14M10 11v6M14 11v6",
  up: "M12 19V5M5 12l7-7 7 7",
  connections:
    "M10 14a4 4 0 0 0 6 0l3-3a4 4 0 0 0-6-6l-1 1M14 10a4 4 0 0 0-6 0l-3 3a4 4 0 0 0 6 6l1-1",
  customers:
    "M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM2 21v-1a6 6 0 0 1 12 0v1M16 3.5a4 4 0 0 1 0 7M22 21v-1a6 6 0 0 0-4-5.7",
  dashboard: "M4 13h6v7H4zM14 4h6v16h-6zM4 4h6v5H4z",
  products: "M3 7l9-4 9 4-9 4-9-4zM3 7v10l9 4 9-4V7M12 11v10",
  // A gear: eight teeth round a hub.
  settings:
    "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z",
  // One person: the members who bought a product. Customers draws two.
  users: "M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM4 21v-1a6 6 0 0 1 6-6h4a6 6 0 0 1 6 6v1",
} as const

export type NavIconName = keyof typeof paths

/** Every icon name, for the catalog. */
export const NAV_ICON_NAMES = Object.keys(paths) as NavIconName[]

/** A decorative icon: hidden from assistive technology, so its link or button names itself. */
export function NavIcon({ name }: { name: NavIconName }) {
  return (
    <svg
      aria-hidden="true"
      className="admin-nav-icon"
      fill="none"
      height="1.25em"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      viewBox="0 0 24 24"
      width="1.25em"
    >
      <path d={paths[name]} />
    </svg>
  )
}
